import React, { useEffect, useState } from 'react';
import {
  Button,
  Spin,
  Row,
  Col,
  Table,
  notification,
  Alert,
  Input,
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import assign from 'lodash/assign';
import debounce from 'lodash/debounce';
// import remove from 'lodash/remove';
import map from 'lodash/map';
import { ArrowLeftOutlined } from '@ant-design/icons';
// import includes from 'lodash/includes';
import {
  generatePaginationObj,
  hasAnyPermission,
} from '../../../utilities/helpers';
import { productMangement } from '../../../redux/actions/productAction';
import {
  productSelectionColumns,
  productSelectionTableFiltersList,
} from '../../../constants/catalogue';
import TableFilters from '../../../components/tableFilters';
import {
  ROLE_MARKETING_ADMIN,
  ROLE_MARKETING_MANAGER,
} from '../../../constants/roles';
import ShowPaginationLimits from '../../../components/showPaginationLimits';

const SelectProduct = (props) => {
  const { edit, onSubmitPayload, onMove, initialValues } = props;
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState({
    data: [],
    filters: { is_active: [true] },
    sorters: null,
    pagination: {},
    filterChips: null,
  });
  const [selectedProducts, setSelectedProducts] = useState(initialValues || []);
  const dispatch = useDispatch();
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const userComapnies = useSelector((state) =>
    get(state, 'auth.userCompanies')
  );
  const role = useSelector((state) => get(state, 'auth.role'));

  const [tempFilter, setTempFilter] = useState({
    filterDropdown: {
      brand: false,
    },
    tempFilterChips: {
      company_id: undefined,
    },
    filterValues: {
      company_id: undefined,
      is_active: [true],
    },
  });

  const { offset, limit } = generatePaginationObj(
    get(products, 'pagination.current'),
    get(products, 'pagination.limit')
  );

  const fetchProductCatalogue = (
    page = 1,
    filterObj = { is_active: [true] },
    sorterObj = {},
    filterChipsObj = {},
    perPagelimit = get(products, 'pagination.limit')
  ) => {
    setLoading(true);
    const pageobj = generatePaginationObj(page, perPagelimit);
    dispatch(
      productMangement('list.products', {
        ...pageobj,
        company_id: get(selectedCompany, 'id'),
        ...sorterObj,
        filters: filterObj,
      })
    )
      .then((result) => {
        setProducts({
          data: get(result, 'data'),
          filters: filterObj,
          sorters: sorterObj,
          pagination: {
            ...pageobj,
            total: get(result, 'total'),
            current: page,
          },
          filterChips: filterChipsObj,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    if (selectedProducts.length === 0) {
      notification.error({
        message: 'Product is required',
        description: 'Please select atleast one product to create offering',
      });
      return;
    }
    onSubmitPayload(1, selectedProducts);
  };

  const onChangeQuantity = (quantity, index) => {
    const newSelectedProducts = selectedProducts;
    const product = get(newSelectedProducts, `${index}`);
    assign(product, {
      quantity,
    });
    newSelectedProducts[index] = product;
    setSelectedProducts([...newSelectedProducts]);
  };

  useEffect(() => {
    fetchProductCatalogue();
  }, []);

  const onProductSearch = debounce((inputValue) => {
    fetchProductCatalogue(
      get(products, 'pagination.current'),
      {
        ...get(products, 'filters'),
        name: inputValue,
      },
      get(products, 'sorters'),
      get(products, 'filterChips')
    );
  }, 500);

  return (
    <Spin spinning={loading}>
      <Row className="mt-60">
        <Col xl={6}>
          <div>
            <Input
              placeholder="Search by product Name"
              onChange={(e) => {
                onProductSearch(e.target.value);
              }}
            />
          </div>
        </Col>

        {hasAnyPermission(
          [ROLE_MARKETING_ADMIN, ROLE_MARKETING_MANAGER],
          [get(role, 'role_code')]
        ) && (
          <Col xl={24}>
            <div
              className="d-flex filter"
              style={{
                alignItems: 'flex-start',
                marginBottom: '0px',
              }}
            >
              <TableFilters
                filtersList={productSelectionTableFiltersList(userComapnies)}
                tableData={products}
                fetchTableData={fetchProductCatalogue}
                tempFilter={tempFilter}
                setTempFilter={setTempFilter}
                roleCode={get(role, 'role_code')}
              />
            </div>
          </Col>
        )}

        <Col xl={24}>
          <div
            className="d-flex filter"
            style={{ justifyContent: 'space-between' }}
          >
            <ShowPaginationLimits
              tableData={products}
              offset={offset}
              limit={limit}
              fetchTableData={fetchProductCatalogue}
              filterChips={get(tempFilter, 'tempFilterChips')}
            />
          </div>
        </Col>

        <Col xl={24}>
          <Table
            size="small"
            title={() =>
              selectedProducts.length > 0 && (
                <Alert
                  message={`${selectedProducts.length} Products selected`}
                  type="success"
                />
              )
            }
            rowKey="id"
            className="product-table"
            dataSource={get(products, 'data')}
            columns={productSelectionColumns(
              true,
              get(role, 'role_code'),
              selectedProducts,
              onChangeQuantity
            )}
            onChange={(paginationObj, filterObj, sorterObj) => {
              fetchProductCatalogue(
                get(paginationObj, 'current'),
                get(products, 'filters'),
                get(sorterObj, 'order')
                  ? {
                      sortBy: get(sorterObj, 'field'),
                      sortDir:
                        get(sorterObj, 'order') === 'ascend' ? 'ASC' : 'DESC',
                    }
                  : {},
                get(products, 'filterChips')
              );
            }}
            rowSelection={{
              type: 'radio',
              onSelect: (record) => {
                setSelectedProducts([assign(record, { quantity: 1 })]);
              },
              getCheckboxProps: (record) =>
                edit && {
                  disabled: get(record, 'id') !== get(selectedProducts, '0.id'),
                  id: get(record, 'id'),
                },
              // onSelect: (record, selected) => {
              //   if (selected) {
              //     setSelectedProducts([
              //       ...selectedProducts,
              //       assign(record, { quantity: 1 }),
              //     ]);
              //   } else {
              //     remove(selectedProducts, ['id', get(record, 'id')]);
              //     setSelectedProducts([...selectedProducts]);
              //   }
              // },
              // onSelectAll: (selected, selectedRows, changeRows) => {
              //   if (selected) {
              //     setSelectedProducts([
              //       ...selectedProducts,
              //       ...map(selectedRows, (product) => ({
              //         ...product,
              //         quantity: 1,
              //       })),
              //     ]);
              //   } else {
              //     const changeRowsIds = map(changeRows, 'id');
              //     remove(selectedProducts, (pro) =>
              //       includes(changeRowsIds, get(pro, 'id'))
              //     );
              //     setSelectedProducts([...selectedProducts]);
              //   }
              // },
              selectedRowKeys: map(selectedProducts, 'id'),
            }}
            pagination={{
              showSizeChanger: false,
              position: ['bottomCenter'],
              hideOnSinglePage: true,
              pageSize: get(products, 'pagination.limit'),
              total: get(products, 'pagination.total'),
              current: get(products, 'pagination.current'),
            }}
          />
        </Col>
      </Row>
      <Row justify="center" className="mt-60">
        <Col xl={8}>
          <Button
            className="default-primary-btn"
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => onMove(0)}
          >
            Back
          </Button>
        </Col>
        <Col xl={8} />
        <Col xl={8}>
          <Button
            onClick={onSubmit}
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default SelectProduct;
